module.exports = __webpack_public_path__ + "static/media/consulta.3fd0cbc3.png";